const en = {
  common: {
    // number: 'Number'
  }
}

export default en
